import type { TopBarUserProps } from '../interfaces';
import { PresenceDialog } from 'Components/PresenceDialog';
import { IconSvg } from 'Components/shared/Icon';
import { SipConnectionStatus } from 'Components/TopBar/SipConnectionStatus';
import { IS_BETA_ENV, COMMUNICATOR_CURRENT_VERSION_URL } from 'Constants/env';
import { MobXProviderContext, observer } from 'mobx-react';
import React from 'react';
import { Grid, Message } from 'semantic-ui-react';
import type { RootStoreProps } from 'Stores/RootStore.types';
import {
  ANALYTICS_EVENT_USER_MENU_OPENED,
  pushToGTMDataLayer,
} from 'Utils/analytics';
import { Styled } from './index.styles';
import { TopBarProfileStatusButton } from './TopBarProfileStatusButton';
import { UserDropdownMenu } from './UserDropdownMenu';

export const TopBarUser: React.FC<TopBarUserProps> = observer(
  ({ testid: parentTestid }) => {
    const { person } = React.useContext<RootStoreProps>(MobXProviderContext);

    const [showMessageStatusModal, setShowMessageStatusModal] =
      React.useState(false);
    const [showHeaderDropdown, setShowHeaderDropdown] = React.useState(false);

    React.useEffect(() => {
      if (showHeaderDropdown) {
        pushToGTMDataLayer(ANALYTICS_EVENT_USER_MENU_OPENED);
      }
    }, [showHeaderDropdown]);

    const testid = `${parentTestid}-topBarUser`;

    return (
      <Grid.Column className="profile-menu-wrapper">
        <Grid.Column className="app-header-user">
          <Styled.RightHeaderWrapper>
            {IS_BETA_ENV && (
              <Styled.BetaRef
                href={COMMUNICATOR_CURRENT_VERSION_URL}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Styled.BetaButton>
                  <Styled.BetaIcon>{IconSvg['resync']}</Styled.BetaIcon>
                  <Styled.BetaText>Switch to current version</Styled.BetaText>
                </Styled.BetaButton>
              </Styled.BetaRef>
            )}
            {person.selectPersonById(person.loggedInPersonId)?.case({
              pending: () => <strong>Loading...</strong>,
              rejected: () => (
                <Message visible error content="Failed to load Person " />
              ),
              fulfilled: (data) => (
                <>
                  <SipConnectionStatus {...{ testid }} />
                  <UserDropdownMenu
                    open={showHeaderDropdown}
                    onOpenChange={setShowHeaderDropdown}
                    setShowMessageStatusModal={setShowMessageStatusModal}
                    testid={testid}
                  >
                    <TopBarProfileStatusButton
                      {...{ testid }}
                      displayName={data.name}
                      displayAvatar={data.avatarUrl}
                    />
                  </UserDropdownMenu>
                </>
              ),
            })}
          </Styled.RightHeaderWrapper>
          <PresenceDialog
            open={showMessageStatusModal}
            onClose={() => setShowMessageStatusModal(!showMessageStatusModal)}
          />
        </Grid.Column>
      </Grid.Column>
    );
  }
);
